module.exports = __webpack_public_path__ + "static/media/15.113ffc6e.png";